import React from "react";
import { useHistory } from "react-router-dom";
import i18n from "i18n";
import AdminLayout from "../../../../components/MainApp/layouts/DesktopLayout";
import ExtraMenuItem from "../../../../components/MainApp/layouts/ExtraMenuItem";
import styles from "./AuditoriaDeStock.module.scss";
import { goToCreateAudit, goToViewAudits } from "./auditStockNavigation";

const AuditoriaDeStock = () => {
  const history = useHistory();
  const headerOptions = [];

  const content = (
    <div className={styles["extra-menu-content-stock"]}>
      <div className={styles["extra-menu-list"]}>
        <div
          className={styles["extra-menu-item-container"]}
          onClick={() => goToCreateAudit(history)}
        >
          <ExtraMenuItem title={i18n.t("create.stock.audit")} arrow={true} />
        </div>

        <div
          className={styles["extra-menu-item-container"]}
          onClick={() => goToViewAudits(history)}
        >
          <ExtraMenuItem title={i18n.t("view.stock.audit")} arrow={true} />
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles["extra-menu-container"]}>
      <AdminLayout
        headerTitle={i18n.t("stock.audit")}
        headerOptions={headerOptions}
        content={content}
        goBackFunc={() => history.push("/admin/stock")}
      />
    </div>
  );
};

export default AuditoriaDeStock;